import { render, staticRenderFns } from "./listado_de_gestiones_atrasadas_segun_evento.vue?vue&type=template&id=97ce6594"
import script from "./listado_de_gestiones_atrasadas_segun_evento.vue?vue&type=script&lang=js"
export * from "./listado_de_gestiones_atrasadas_segun_evento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports